import { render } from "./template.html?vue&type=template&id=2290cd7f&scoped=true&external"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"

import "./style.css?vue&type=style&index=0&id=2290cd7f&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2290cd7f"]])

export default __exports__